// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__Vbh36","copyright":"Footer_copyright__YtgqX","link":"Footer_link__gMKkA"};